export default __webpack_public_path__ + "static/media/1_ru.f30558e5.png";